'use strict';

module.exports = {
    LANG: 'tr-tr',
    SIGN: 'Kaydol',
    REGISTER: 'Kayıt',
    QUICK_ACCESS: 'Hızlı giriş',
    SIGN_JOIN: 'Ücretsiz olarak Kaydol ya da Katıl!',
    NOT_MEMBER: 'Üye Değil misiniz?',
    ALREADY_MEMBER: 'Halihazırda AliExpress/Alibaba üyesi misiniz?',
    SHOW_ALL: 'Göstermek tüm',
    HIDE: 'Gizle',
    GUID: "AliExpress'te satış yapmak",
    GUID_HREF: 'buraya tıklayın'
};